import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, catchError, map, mergeMap, filter } from 'rxjs';
import { finalizeLoader } from '@app/shared/components';
import { studentsActions } from '../actions/students.actions';
import { HttpService } from '../services/http.service';
import { Store } from '@ngrx/store';
import { selectPagination } from '../selectors/students.selector';
import { concatLatestFrom } from '@ngrx/operators';

@Injectable()
export class StudentsEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);
    private readonly store = inject(Store);

    getStudents$ = createEffect(() => {
        return this.actions.pipe(
            ofType(studentsActions.getStudents),
            mergeMap(({ page, limit }) => {
                return this.httpService.getStudents(page, limit).pipe(
                    finalizeLoader('students-get'),
                    map((payload) => studentsActions.getStudentsSuccess({ payload })),
                    catchError(() => of(studentsActions.getStudentsError())),
                );
            }),
        );
    });

    reloadStudents$ = createEffect(() => {
        return this.actions.pipe(
            ofType(studentsActions.reloadStudents),
            concatLatestFrom(() => this.store.select(selectPagination)),
            map(([, pagination]) => pagination),
            filter((pagination) => pagination !== null),
            map((pagination) => {
                return studentsActions.getStudents({ page: pagination.currentPage, limit: pagination?.limit });
            }),
        );
    });
}
